<template>
    <div class="app-container">
        <div class="base-create-container">
            <!--创建-->
            <div class="head-container">
                <div class="left-head-container" @click="backList">
                    <svg t="1749015789538" class="icon" viewBox="0 0 1063 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4561" width="26" height="26"><path d="M248.32 148.992z" fill="#cdcdcd" p-id="4562"></path><path d="M765.44 939.008l-415.744-425.472 416.256-415.744c9.728-9.728 9.728-25.6 0-35.328s-25.6-9.728-35.328 0l-432.128 435.2c-9.728 9.728-9.728 25.6 0 35.328l432.128 441.856c9.728 9.728 25.6 9.728 35.328 0 9.216-10.24 9.216-26.112-0.512-35.84z" p-id="4563" fill="#cdcdcd"></path></svg>
                </div>
                <div class="right-head-container">活动量表管理</div>
            </div>
            <div class="scale-container">
                <div class="scale-container-l">
                    <el-scrollbar class="scrollbar-container-l">
                        <div class="title-container">
                            <div class="title-container-l">竞赛量表</div>
                            <div class="title-container-r">
                                <el-dropdown v-if="scaleTypeList && scaleTypeList.length > 0" slot="dropdown">
                                    <el-tag type="primary" class="scale-tag">
                                        ⇅ {{scaleTypeName}}
                                    </el-tag>
                                    <template #dropdown>
                                        <el-dropdown-menu>
                                            <el-dropdown-item :disabled="scaleType===item.value" v-for="item in scaleTypeList" @click="changeScaleType(item)">{{item.name}}</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </template>
                                </el-dropdown>
                            </div>
                        </div>
                        <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                         height="calc(100vh - 240px)" :data="scaleList">
                            <el-table-column type="index" align="center" label="序号" width="60" />
                            <el-table-column align="center" label="序号"  prop="scaleName"/>
                            <el-table-column fixed="right" width="100" label="操作" align="center"
                                             class-name="small-padding fixed-width">
                                <template #default="scope">
                                    <el-dropdown>
                                    <span class="el-dropdown-link">
                                      <el-button type="primary" size="small">操作</el-button>
                                    </span>
                                        <template #dropdown>
                                            <el-dropdown-menu>
                                                <el-dropdown-item @click="viewScale(scope.row)">预览</el-dropdown-item>
                                                <el-dropdown-item @click="createScale(scope.row)">添加</el-dropdown-item>
                                                <el-dropdown-item @click="delScale(scope.row)">删除</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                </template>

                            </el-table-column>
                        </el-table>
                    </el-scrollbar>
                </div>
                <div class="scale-container-r">
                    <el-scrollbar class="scrollbar-container-r">
                        <el-form ref="scaleForm" :model="scaleForm"
                                 :rules="scaleRules"
                                 label-width="100px">
                            <el-row class="mt10">
                                <el-col :span="22">
                                    <el-form-item label="量表标题" prop="scaleName">
                                        <el-input v-model="scaleForm.scaleName" placeholder="最多64个字" maxlength="64" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="22">
                                    <el-form-item label="量表类型" prop="scaleType">
                                        <el-radio-group v-model="scaleForm.scaleType">
                                            <el-radio label="复审量表" :value="Number(1)"/>
                                            <el-radio label="终审量表" :value="Number(2)"/>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="量表总分" prop="scaleScore">
                                        <el-input v-model="scaleForm.scaleScore" disabled />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="22">
                                    <el-form-item label="量表评审项" prop="eduItemList">
                                        <div class="mb30" v-for="(item, index) in scaleForm.eduItemList"
                                             style="width: 98%"
                                             @mouseover="showOperate(item,index)"
                                             @mouseout="hideOperate(item,index)">
                                            <div>
                                                <h3 style="margin: 0 0;">
                                                    <span style="padding-right: 10px;">
                                                        {{ index + 1 }}.{{item.itemName }}
                                                    </span>
                                                    <span style="color: #efa030;font-weight: normal;font-size: 14px;">
                                                        (满分：{{item.itemScore }})
                                                    </span>
                                                </h3>
                                            </div>
                                            <div>
                                                <el-radio-group disabled class="ml-4">
                                                    <el-radio label="1" size="small"
                                                              v-for="(items, indexs) in item.itemList">
                                                        <span style="color: #333;">{{ items.itemName }}</span>
                                                        <span style="color: #efa030;">
                                                            (分值：{{ items.itemScore }})
                                                        </span>
                                                    </el-radio>
                                                </el-radio-group>
                                            </div>
                                            <el-row v-show="showIndex === index">
                                                <el-col :span="8">
                                                    <el-button @click="nextQuestion(index)" type="primary" link>此项后插入</el-button>
                                                </el-col>
                                                <el-col :span="16">
                                                    <el-button @click="editQuestion(index)" type="primary" size="small">编辑</el-button>
                                                    <el-button @click="copyQuestion(index)" type="primary" size="small">复制</el-button>
                                                    <el-button @click="delQuestion(index)" type="primary" size="small">删除</el-button>
                                                    <el-button @click="topQuestion(index)" type="primary" size="small">上移</el-button>
                                                    <el-button @click="bottomQuestion(index)" type="primary" size="small">下移</el-button>
                                                </el-col>
                                            </el-row>
                                        </div>

                                        <dataEmpty v-if="scaleForm.eduItemList.length === 0" title="暂无评审项"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row justify="center" class="mt10">
                                <el-button style="width: 200px;"  type="primary" @click="createScaleItem">新增评审项</el-button>
                            </el-row>
                        </el-form>
                    </el-scrollbar>
                </div>
            </div>

            <div>
                <div class="disflex-row-center cusbtbtn" style="left:216px;">
                    <el-button type="info" @click="viewScaleNow">预 览</el-button>
                    <el-button type="primary" @click="submitScale">保 存</el-button>
                    <el-button >取 消</el-button>
                </div>
            </div>

        </div>


        <el-dialog :title="editItem != null ? '编辑评审项' : '新增评审项'" v-model="isAddItemShow" width="60%">
            <el-form ref="itemForm" :model="itemForm" :rules="itemFormRules" label-width="120px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="评审项名称" prop="itemName">
                            <el-input v-model="itemForm.itemName" placeholder="请输入评审项名称，最多50字" maxlength="50" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="评审项细则" prop="itemList">
                            <el-table ref="itemList" border :data="itemForm.itemList" style="width: 100%"
                                      max-height="250">
                                <el-table-column prop="itemName" align="center" label="细则名称">
                                    <template #default="scope">
                                        <el-input v-model="scope.row.itemName" placeholder="最多32个字" maxlength="32" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="itemScore" align="center" label="细则分数">
                                    <template #default="scope">
                                        <el-input-number step-strictly v-model="scope.row.itemScore" :min="0" :max="100" />
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" align="center" label="操作" width="200">
                                    <template #default="scope">
                                        <el-button link type="primary" size="small"
                                                   @click.prevent="deleteRow(scope.$index)">
                                            删除
                                        </el-button>
                                        <el-button link type="primary" size="small"
                                                   @click.prevent="moveUpRow(scope.$index)">
                                            上移
                                        </el-button>
                                        <el-button link type="primary" size="small"
                                                   @click.prevent="downRow(scope.$index)">
                                            下移
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="addChildItem">增加细则</el-button>
                    <el-button type="primary" @click="submitItem">确 定</el-button>
                    <el-button @click="isAddItemShow = !isAddItemShow">取 消</el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog :title="'量表预览'" v-model="isViewScaleShow" width="60%">
            <div class="mb30" v-for="(item, index) in scaleForm.eduItemList"
                 style="width: 98%">
                <div>
                    <h3 style="margin: 0 0;">
                            <span style="padding-right: 10px;">
                                {{ index + 1 }}.{{item.itemName }}
                            </span>
                        <span style="color: #efa030;font-weight: normal;font-size: 14px;">
                            (满分：{{item.itemScore }})
                        </span>
                    </h3>
                </div>
                <div>
                    <el-radio-group disabled class="ml-4">
                        <el-radio label="1" size="small"
                                  v-for="(items, indexs) in item.itemList">
                            <span style="color: #333;">{{ items.itemName }}</span>
                            <span style="color: #efa030;">
                                                            (分值：{{ items.itemScore }})
                                                        </span>
                        </el-radio>
                    </el-radio-group>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty";
import {createScale,listScale,infoScale,deleteScale} from "@/api/admin/eduScale"

export default {
    name: "activityScale",
    components: {dataEmpty},
    data() {
        return {
            showIndex:null,
            isAddItemShow:false,
            isViewScaleShow:false,
            editItem: null,
            createItem: null,
            scaleTypeName:'全部',
            scaleType:0,
            scaleScore:100,
            scaleTypeList:[
                { name: '全部', value: 0 },
                { name: '复审量表', value: 1 },
                { name: '终审量表', value: 2 },
            ],
            queryForm:{
                businessType:2,
                scaleType:0,
            },
            scaleList:[],
            scaleForm: {
                scaleName: '',
                businessType:2,
                scaleType:1,
                scaleScore:100,
                eduItemList: []
            },
            scaleRules:{
                scaleName: [{ required: true, message: "请输入量表标题", trigger: "blur" },],
                scaleType: [{ required: true, message: "请选择量表类型", trigger: "change" },],
                scaleScore: [{ required: true, message: "请输入量表总分", trigger: "blur" },],
                eduItemList:{ required: true, validator: this.checkEduItem }
            },
            itemForm:{
                itemNo:1,
                itemName:'',
                itemScore:1,
                itemList:[
                    { itemName: '', itemNo: 1, itemScore: 1 }
                ],
            },
            itemFormRules:{
                itemName: [{ required: true, message: "请输入评审项名称", trigger: "blur" },],
                itemScore: [{ required: true, message: "请输入评审项名称", trigger: "change" },],
                itemList:{ required: true, validator: this.checkItemList }
            }
        };
    },
    created() {
        this.queryScaleList();
    },
    mounted() {
    },
    unmounted() {},
    computed: {},
    methods: {
        backList(){
            this.replace('/activity')
        },
        changeScaleType(item){
            this.scaleTypeName = item.name;
            this.scaleType = item.value;
            this.queryForm.scaleType = this.scaleType;
            this.queryScaleList();
        },
        queryScaleList(){
            listScale(this.queryForm).then(res => {
                if (res.data.code === 1) {
                    this.scaleList = res.data.data;
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        checkEduItem(rule, value, callback){
            if (this.scaleForm.eduItemList.length===0) {
                callback(new Error('请添加量表评审项'))
            } else {
                callback()
            }
        },
        checkItemList(rule, value, callback){
            var result = true;
            for (var i = 0; i < this.itemForm.itemList.length; i++) {
                var e = this.itemForm.itemList[i];
                if (e.itemName == '' || (e.itemScore == '' && e.itemScore != 0)) {
                    result = false
                    break;
                }
            }
            if (result) {
                callback()
            } else {
                callback(new Error('请填写完整信息'))
            }
        },
        createScaleItem(){
            this.editItem = null;
            this.createItem = null;
            this.itemForm = {
                itemNo:1,
                itemName:'',
                itemScore:0,
                itemList:[],
            }
            this.isAddItemShow = true;
        },
        addChildItem(){
            this.itemForm.itemList.push(
              { itemName: '', itemNo: 1, itemScore: 1 }
            )
        },
        deleteRow(index) {
            console.log(index)
            if (this.itemForm.itemList.length == 1) {
                this.$message.error("不能全部删除")
            } else {
                this.itemForm.itemList.splice(index, 1)
            }
        },
        moveUpRow(index) {
            if (index != 0) {
                this.itemForm.itemList[index] = this.itemForm.itemList.splice(index - 1, 1, this.itemForm.itemList[index])[0];
            } else {
                this.itemForm.itemList.push(this.itemForm.itemList.shift());
            }
        },
        downRow(index) {
            if (index != this.itemForm.itemList.length - 1) {
                this.itemForm.itemList[index] = this.itemForm.itemList.splice(index + 1, 1, this.itemForm.itemList[index])[0];
            } else {
                this.itemForm.itemList.unshift(this.itemForm.itemList.splice(index, 1)[0]);
            }
        },
        submitItem(){
            this.$refs["itemForm"].validate(valid => {
                if (valid) {
                    let score = 0;

                    this.itemForm.itemList.forEach((e, i) => {
                        e.itemNo = i+1;
                        score = score+e.itemScore;
                    })
                    this.itemForm.itemScore = score;
                    if (this.editItem != null) {
                        this.scaleForm.eduItemList[this.editItem] = this.itemForm
                    } else if (this.createItem != null) {
                        this.scaleForm.eduItemList.splice(this.createItem + 1, 0, this.itemForm)
                    } else {
                        this.scaleForm.eduItemList.push(this.itemForm)
                    }
                    this.isAddItemShow = false;
                }
            });
        },
        showOperate(item,index){
            this.showIndex = index
        },
        hideOperate(item,index){
            this.showIndex = null
        },
        nextQuestion(index) {
            this.createItem = index;
            this.itemForm = {
                itemNo:1,
                itemName:'',
                itemScore:1,
                itemList:[
                    { itemName: '', itemNo: 1, itemScore: 1 }
                ],
            }
            this.isAddItemShow = true;
        },
        editQuestion(index) {
            this.editItem = index;
            this.itemForm = JSON.parse(JSON.stringify(this.scaleForm.eduItemList[index]));
            this.isAddItemShow = true;
        },
        copyQuestion(index) {
            this.scaleForm.eduItemList.splice(index, 0, this.scaleForm.eduItemList[index])
        },
        delQuestion(index) {
            this.scaleForm.eduItemList.splice(index, 1)
        },
        topQuestion(index) {
            if (index != 0) {
                this.scaleForm.eduItemList[index] = this.scaleForm.eduItemList.splice(index - 1, 1, this.scaleForm.eduItemList[index])[0];
            } else {
                this.$message.error('第一项不能上移')
            }
        },
        bottomQuestion(index) {
            if (index != this.scaleForm.eduItemList.length - 1) {
                this.scaleForm.eduItemList[index] = this.scaleForm.eduItemList.splice(index + 1, 1, this.scaleForm.eduItemList[index])[0];
            } else {
                this.$message.error('最后一项不能下移')
            }
        },
        submitScale(){
            this.$refs["scaleForm"].validate(valid => {
                if (valid) {
                    let score = 0;
                    this.scaleForm.eduItemList.forEach((e, i) => {
                        e.itemNo = i+1;
                        score = score+e.itemScore;
                    })
                    if (score != 100){
                        this.$message.error('量表分数不满足百分制，请调整')
                        return;
                    }

                    createScale(this.scaleForm).then(res => {
                        if (res.data.code === 1) {
                            this.$message.success('操作成功')
                            this.scaleForm = {
                                scaleName: '',
                                businessType:1,
                                scaleType:1,
                                scaleScore:100,
                                eduItemList: []
                            }
                            this.queryScaleList()
                        } else {
                            this.$message.error('操作失败')
                        }
                    })
                }
            })
        },
        viewScale(row){
            infoScale({ scaleId: row.scaleId }).then(res => {
                this.scaleForm = res.data.data;
                this.isViewScaleShow = true;
            })
        },
        createScale(row){
            infoScale({ scaleId: row.scaleId }).then(res => {
                this.scaleForm = res.data.data;
            })
        },
        delScale(row){
            deleteScale({ scaleId: row.scaleId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success('删除成功')
                    this.queryScaleList()
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        viewScaleNow(){
            this.isViewScaleShow = true;
        }
    }
};
</script>
<style scoped>
.base-create-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    overflow-y: auto!important;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 40px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 40px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.scale-container{
    width: 100%;
    height: calc(100vh - 180px);
    display: flex;
}
.scale-container-l{
    height: calc(100vh - 200px);
    width: 300px;
    border: 1px solid #cdcdcd;
    margin-left: 10px;
    border-radius: 4px;
    padding: 10px 0 10px 10px;
}
.scrollbar-container-l{
    height: calc(100vh - 200px);
    width: 300px;
}
.title-container{
    width: 100%;
    height: 40px;
    display: flex;
}
.title-container-l{
    width: 90%;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    color: #ff7f2e;
    font-weight: bold;
}
.scale-tag{
    height: 24px;
    border: 1px solid #1f89de;
    line-height: 24px;
    color: #1f89de;
    margin-right: 10px;
    margin-top: 8px;
}
.scale-container-r{
    height: calc(100vh - 200px);
    width: calc(100% - 330px);
    border: 1px solid #cdcdcd;
    margin-left: 10px;
    border-radius: 4px;
    padding: 10px 5px;
}
.scrollbar-container-r{
    height: calc(100vh - 200px);
    width: 100%;
}
</style>